import { AuthenticationContextValue } from '../../authentication';
import ACTIONS from '../app.constants';

export const userAuthenticated = (context: AuthenticationContextValue) => ({
    type: ACTIONS.USER_AUTHENTICATED,
    payload: context,
});

export const getAuthenticationToken = (callback: Function) => {
    return {
        type: ACTIONS.GET_AUTHENTICATION_TOKEN,
        payload: { callback },
    };
};

export const getCitationAuthenticationToken = (callback: Function) => {
    return {
        type: ACTIONS.GET_CITATIONS_AUTHENTICATION_TOKEN,
        payload: { callback },
    };
};
